import { createContext } from 'react';

export const FavoritesContext = createContext(null);